<!--
 * @Descripttion: 
 * @version: 
 * @Author: wanglikun
 * @Date: 2022-09-13 09:37:08
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-10-17 12:21:29
-->
<template>
  <Tabs :activeKey="activePane" hide-add type="editable-card" @tabClick="tabClick" @edit="editTab">
    <TabPane v-for="pane in tabs" :key="pane.path" :tab="tab(pane)" :closable="pane.path !== '/'"> </TabPane>
  </Tabs>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { Tabs, TabPane } from 'ant-design-vue'
  import type { TabsProps } from 'ant-design-vue'
  import { useRouter, useRoute } from 'vue-router'
  import { useTabStore } from '@jms/store/tabs'
  import { lang } from '@jms/utils'
  const tabStore = useTabStore()
  const router = useRouter()
  const route = useRoute()

  const activePane = computed(() => {
    return route.fullPath
  })
  const tabs = computed(() => {
    return tabStore.getTabs
  })
  const tab = computed(() => {
    return (pane: Record<string, any>) => {
      return lang(pane?.meta?.title || '首页')
    }
  })

  const tabClick: TabsProps['onTabClick'] = (path) => {
    router.replace(path as string)
  }
  const editTab: TabsProps['onEdit'] = (path) => {
    const index = tabs.value.findIndex((_) => _.path === path)
    if (path === route.fullPath) {
      const jumpPath = tabs.value[index - 1]
      router.replace(jumpPath.path)
    }
    tabStore.delTabs(path as string)
  }
</script>
<style lang="less" scoped>
  .ant-tabs {
    overflow: initial;
    &-top {
      :deep(.ant-tabs-nav) {
        margin-bottom: 1px;
        .ant-tabs-tab {
          border-radius: 0;
        }
      }
    }
    &-card {
      :deep(.ant-tabs-nav) > .ant-tabs-tab {
        background-color: @white;
      }
    }
  }
</style>
